import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=0245f57c"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=0245f57c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports